let cs = vocento.tracking.comscore;

/**
 * @param t
 * @return {string}
 */
function normat(t) {
  let str = t;
  let lDcs = [{b: "a", l: /[\u00e1\u00e0\u00e2\u00e3\u00e4]/g}, {b: "e", l: /[\u00e9\u00e8\u00ea\u00eb]/g}, {
    b: "i",
    l: /[\u00ed\u00ec\u00ee\u00ef]/g
  }, {b: "o", l: /[\u00f3\u00f2\u00f4\u00f5\u00f6]/g}, {b: "u", l: /[\u00fa\u00f9\u00fb\u00fc]/g}, {
    b: "n",
    l: /[\u00f1]/g
  }, {b: "c", l: /[\u00e7]/g}, {b: "-", l: /[\. \-]+/g}, {b: "_", l: /[|/_]+/g}, {b: "", l: /[^a-z_0-9-]+/g}, {
    b: "-",
    l: /[\-]+/g
  }, {b: "_", l: /[\-]*_[\-]*/g}];
  str = str.toLowerCase();
  for (let i = 0; i < lDcs.length; i++) {
    str = str.replace(lDcs[i].l, lDcs[i].b);
  }
  return str;
}

/**
 * Return string cookie content
 * @param name
 * @returns {string}
 */
function getCookieContent(name) {
  let value = "; " + document.cookie;
  let parts = value.split("; " + name + "=");
  if (parts.length === 2) return parts.pop().split(";").shift();
}

/**
 * Get
 * @param key
 * @returns {string}
 */
function getUserData(key) {
  let value = '';
  let cookieContent = getCookieContent('voc_uid');
  if(typeof cookieContent !== 'undefined') {
    try {
      let vocUid = JSON.parse(decodeURIComponent(cookieContent));
      if (typeof vocUid === 'object' && vocUid.hasOwnProperty(key)) {
        value = vocUid[key];
      }
    } catch (err) {}
  }
  return value;
}

/**  voc_user */
cs.voc_tusr = window.__VOONTO__.getUserType();
cs.voc_usrid = getUserData('uid').replace(/=/g, ".");
cs.voc_usrcp = getUserData('zip');
cs.voc_usrgen = getUserData('gender');
cs.voc_usrag = getUserData('age');

/** voc_s4 normat */
cs.voc_s4 = normat(cs.voc_s4);

/** voc_ho */
(document.referrer === ('//' + document.domain + '/') || document.referrer === ('//' + document.domain + '/index.asp') || document.referrer === ('//' + document.domain + '/index.php') || document.referrer === ('//' + document.domain + '/index.html')) ? cs.voc_ho = 1 : cs.voc_ho = 0;

/** voc_name */
cs.voc_name = (cs.voc_se !== '' ? cs.voc_se + '.' : '') + (cs.voc_s1 !== '' ? cs.voc_s1 + '.' : '') + (cs.voc_s2 !== '' ? cs.voc_s2 + '.' : '') + (cs.voc_s3 !== '' ? cs.voc_s3 + '.' : '') + (cs.voc_s4 !== '' ? cs.voc_s4 + '.' : '') + cs.voc_tn;

/** segments */
if (typeof cs.voc_se === 'undefined') {
  let segments = window.location.href.split("/");
  try {
    if(3 in segments) {
      cs.voc_se = segments[3];
      if (segments[3].indexOf(".htm") > -1) {
        cs.voc_se = '';
      }
      if (segments[3].indexOf(".php") > -1) {
        cs.voc_se = '';
      }
      if (segments[3].indexOf(".asp") > -1) {
        cs.voc_se = '';
      }
      if (segments[3].indexOf(".php") > -1) {
        cs.voc_se = '';
      }
    }
  } catch (err) {
  }

  try {
    if(4 in segments) {
      cs.voc_s1 = segments[4];
      if (segments[4].indexOf(".htm") > -1) {
        cs.voc_s1 = '';
      }
      if (segments[4].indexOf(".php") > -1) {
        cs.voc_s1 = '';
      }
      if (segments[4].indexOf(".asp") > -1) {
        cs.voc_s1 = '';
      }
      if (segments[4].indexOf(".php") > -1) {
        cs.voc_s1 = '';
      }
    }
  } catch (err) {
  }

  try {
    if(5 in segments) {
      cs.voc_s2 = segments[5];
      if (segments[5].indexOf(".htm") > -1) {
        cs.voc_s2 = '';
      }
      if (segments[5].indexOf(".php") > -1) {
        cs.voc_s2 = '';
      }
      if (segments[5].indexOf(".asp") > -1) {
        cs.voc_s2 = '';
      }
      if (segments[5].indexOf(".php") > -1) {
        cs.voc_s2 = '';
      }
    }
  } catch (err) {
  }

  try {
    if(6 in segments) {
      cs.voc_s3 = segments[6];
      if (segments[6].indexOf(".htm") > -1) {
        cs.voc_s3 = '';
      }
      if (segments[6].indexOf(".php") > -1) {
        cs.voc_s3 = '';
      }
      if (segments[6].indexOf(".asp") > -1) {
        cs.voc_s3 = '';
      }
      if (segments[6].indexOf(".php") > -1) {
        cs.voc_s3 = '';
      }
    }
  } catch (err) {
  }

  cs.voc_pr = 1;
  cs.voc_pu = '';
}

/** adblock Check */
if (typeof checkAdBlock === 'undefined') {
  cs.voc_adb = 1;
}
/** Krux check */
if (typeof Krux === 'undefined') {
  cs.voc_krux = "0";
}
/** voc_adp */
if (getCookieContent("voc_mobile") === "activo") {
  cs.voc_adp = "2";
}

/** replace incorrect url's */
let lineaurl = "";
if (document.location.href.indexOf("/20") > -1) {
  lineaurl = window.location.href;
  lineaurl = lineaurl.replace("www-origin", "www");
  lineaurl = lineaurl.replace("www-new.abc.es", "www.abc.es");
  lineaurl = lineaurl.replace("sevilla-new.abc.es", "sevilla.abc.es");
  lineaurl = lineaurl.replace("sevilla-origin.abc.es", "sevilla.abc.es");
  lineaurl = lineaurl.replace("www.abcdesevilla.es", "sevilla.abc.es");
}

/** Export to window */
/** remove tgm website after remove datalayer gtm
  window.tgm_website = vocento.tracking.dataLayer.tgm_website;
  window.dataLayer = vocento.tracking.dataLayer;
*/

/** others export */
window.lineaurl = lineaurl;

/** comscore export */
for (let key in cs) {
  if (cs.hasOwnProperty(key)) {
    window[key] = cs[key];
  }
}

/** root export */
for (let key in vocento.tracking.root) {
  if (vocento.tracking.root.hasOwnProperty(key)) {
    window[key] = vocento.tracking.root[key];
  }
}



// WEBPACK FOOTER //
// ./src/tracking/initVars.js